//@ts-nocheck

import axios from "axios";

const DEFAULT_TIMEOUT = 10000;

interface IHttpServerConfig {
  timeout?: number;
}

export class HttpServer {
  readonly get = axios.get;
  readonly put = axios.put;
  readonly post = axios.post;
  readonly delete = axios.delete;

  private static instance: HttpServer;
  static getInstance(options: IHttpServerConfig = {}): HttpServer {
    if (!HttpServer.instance) {
      HttpServer.instance = new HttpServer(options.timeout);
    }
    return HttpServer.instance;
  }

  private constructor(protected httpTimeout: number = DEFAULT_TIMEOUT) {
    axios.interceptors.response.use(null, (error) => {
      const expectedError =
        error.response &&
        error.response.status >= 400 &&
        error.response.status <= 500;

      if (!expectedError) {
        console.log(`http service error : ${error}`);
      }
      return Promise.reject(error);
    });

    axios.defaults.timeout = this.httpTimeout;
  }

  setHeader(key: string, value: string) {
    axios.defaults.headers.common[key] = value;
  }
}
